module.exports = __webpack_public_path__ + "img/circleOrange2b.7107651b.svg";